import React, { memo } from 'react';
import styled from 'styled-components';
import StyledComponentProps from 'utils/types/styled-components-type';

interface Props extends StyledComponentProps {
  children?: JSX.Element | string | null | number | undefined;
  onClick?:
    | ((e?: React.MouseEvent<HTMLDivElement, MouseEvent> | undefined) => void)
    | undefined;
}

const StyledP = styled.p<StyledComponentProps>`
  line-height: ${props => (props.lineheight ? props.lineheight : '20')}px;
  letter-spacing: 0;
  width: ${props => props.width || 'auto'} !important;
  color: ${props =>
    props.color ? props.color : 'var(--heltar-text-primary)'};
  font-size: ${props => (props.fontsize ? props.fontsize : '14')}px;
  font-weight: ${props => (props.fontweight ? props.fontweight : '400')};
  margin-top: ${props => (props.margintop ? props.margintop : '0')}px;
  margin-right: ${props => (props.marginright ? props.marginright : '0')}px;
  margin-left: ${props => (props.marginleft ? props.marginleft : '0')}px;
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0')}px;
  text-align: ${props => (props.textalign ? props.textalign : 'initial')};
  padding: ${props => (props.padding ? props.padding : '0')};
  cursor: ${props => (props.cursor ? props.cursor : 'arrow')};
  text-overflow: ellipsis;
  white-space: ${props => (props.whitespace ? props.whitespace : 'nowrap')};
  overflow: ${props => (props.overflow ? props.overflow : 'hidden')};
`;

export const P = memo((props: Props) => {
  return (
    <StyledP onClick={props.onClick} {...props}>
      {props.children}
    </StyledP>
  );
});
